import { render } from "./Thongkedoanhthu.vue?vue&type=template&id=d668659e&scoped=true&ts=true"
import script from "./Thongkedoanhthu.vue?vue&type=script&lang=ts"
export * from "./Thongkedoanhthu.vue?vue&type=script&lang=ts"

import "./Thongkedoanhthu.vue?vue&type=style&index=0&id=d668659e&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/DieuTri/DieuTri/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d668659e"]])

export default __exports__